import { FC, PropsWithChildren, useCallback, useEffect, useRef } from 'react'
import styles from './EmblaCarousel.module.css'
import classNames from 'classnames'
import { useInView } from 'react-intersection-observer'

interface Props extends PropsWithChildren {
  className?: string
  fadeOutOfView?: boolean
  containerRootOverride?: Element | null
}

export const EmblaSlide: FC<Props> = ({ className, fadeOutOfView, containerRootOverride, children }) => {
  const containerElement = useRef<Element | null>(null)

  const ref = useRef<Element | null>(null)

  const { ref: inViewRef, inView } = useInView({
    threshold: 1,
    root: containerRootOverride ?? containerElement.current,
  })

  useEffect(() => {
    if (ref.current?.parentElement?.parentElement) containerElement.current = ref.current.parentElement?.parentElement
  }, [])

  const setRefs = useCallback(
    (node: HTMLDivElement | null) => {
      ref.current = node
      inViewRef(node)
    },
    [inViewRef],
  )

  return (
    <div
      ref={setRefs}
      className={classNames(
        styles.embla__slide,
        'transition-opacity duration-300 ease-in-out',
        fadeOutOfView && !inView ? 'opacity-30' : 'opacity-100',
        className,
      )}
    >
      {children}
    </div>
  )
}
